var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "view-loader",
    { attrs: { loading: !!_vm.loading } },
    [
      _c("div", { staticClass: "portlet-body form" }, [
        _c("form", { staticClass: "form-horizontal", attrs: { action: "#" } }, [
          _c("div", { staticClass: "form-body" }, [
            _c(
              "h3",
              {
                staticClass: "form-section",
                staticStyle: { "margin-top": "0px" }
              },
              [_vm._v(_vm._s(_vm.trans("importPpk.import.form.header")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("upload-file", {
                    attrs: {
                      name: "file",
                      accept: ".xlsx",
                      errors: _vm.errors,
                      title: _vm.trans(
                        "importPpk.messages.acceptable_import_file_extensions"
                      )
                    },
                    model: {
                      value: _vm.file,
                      callback: function($$v) {
                        _vm.file = $$v
                      },
                      expression: "file"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("hr", { staticStyle: { margin: "0" } }),
            _vm._v(" "),
            _c("div", { staticClass: "form-actions top" }, [
              _c("div", { staticClass: "btn-set pull-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn green-jungle button-save",
                    attrs: {
                      type: "button",
                      id: "button-save-and-back",
                      "data-loading-text":
                        "<i class='fa fa-spinner fa-spin '></i>"
                    },
                    on: { click: _vm.importAddress }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.trans("offer.import.import")) +
                        "\n            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("modal", {
        attrs: { show: _vm.showModal, modalBodyText: _vm.modalBodyText },
        on: {
          close: function($event) {
            _vm.showModal = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("h3", [_vm._v(_vm._s(_vm.trans("importPpk.modal.header")))])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-429be632", { render: render, staticRenderFns: staticRenderFns })
  }
}